import React, { FC, createContext, useContext, useState } from 'react';

import ParentCompanySetupService from 'services/ParentCompanySetup/parentCompanySetup.service';
import { OrganizationDataModel } from 'models/CompanySetup/organizationDataModel.model';

type ParentOrganizationContextType = {
  organizationData: OrganizationDataModel | null;
  setOrganizationData: (data: OrganizationDataModel | null) => void;
  loading: boolean;
  fetchParentOrganization: () => void;
};

export const ParentOrganizationContext =
  createContext<ParentOrganizationContextType>({
    organizationData: null,
    setOrganizationData: () => {},
    loading: false,
    fetchParentOrganization: () => {},
  });

export const useParentOrganizationContext = () => {
  const context = useContext(ParentOrganizationContext);
  if (!context) {
    throw new Error(
      'useParentOrganizationContext must be used within a ParentOrganizationProvider'
    );
  }
  return context;
};

export const ParentOrganizationProvider: FC = ({ children }) => {
  const { fetchParentOrganization, loading } = ParentCompanySetupService();
  const [organizationData, setOrganizationData] =
    useState<OrganizationDataModel | null>(null);

  return (
    <ParentOrganizationContext.Provider
      value={{
        organizationData,
        setOrganizationData,
        loading,
        fetchParentOrganization,
      }}>
      {children}
    </ParentOrganizationContext.Provider>
  );
};
